import * as React from 'react';
import { Body2 } from '@cian/ui-kit';

import * as style from '../../style.css';

export interface IHeaderRowProps {
  floating?: boolean;
  headers: string[];
  rowRef?: React.Ref<HTMLDivElement>;
}

export const HeaderRow = ({ floating = false, headers, rowRef }: IHeaderRowProps) => {
  return (
    <div
      ref={rowRef}
      className={floating ? style['row-floating'] : style['row']}
      data-floating-header={floating ? 'true' : undefined}
      role="row"
    >
      {headers.map((header, columnIndex) => (
        <div className={style['header-cell']} key={columnIndex} role="columnheader">
          {header && <Body2>{header}</Body2>}
        </div>
      ))}
    </div>
  );
};
